/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 18/8/2023
 */


import { Button, Container, Dialog, DialogContent, Typography } from '@mui/material'
import React from 'react'
import { useDispatch } from 'react-redux';
import { signOut } from '../../Store/Actions/signOut';

const TimeoutWarningDialog = ({ open, onClose }) => {

    const dispatch = useDispatch();

    const onLogOutClick = () => {
        dispatch(signOut());
        window.location.reload();
    }

    return (
        <Dialog
            fullWidth={true}
            sx={{
                marginLeft: '25rem',
                marginRight: '25rem',
            }}
            open={open}
            aria-labelledby="session-timeout-warning"
        >
            <DialogContent>
                <Container maxWidth="md">
                    <Typography my={3} variant="h5" color="text.primary" textAlign="center" fontWeight="bold">
                        Session Timeout
                    </Typography>

                    <Typography my={3} component="div" color="text.primary" textAlign="center" fontWeight="400">
                        You&apos;re being timed out due to inactivity.
                        Please choose to stay signed in or to logout. Otherwise, you will be logged out automatically.
                    </Typography>

                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: "1rem" }}>
                        <Button onClick={onLogOutClick} style={{margin: '0.5rem', width: "10rem"}} fullWidth variant="contained">Logout</Button>
                        <Button onClick={() => onClose()} style={{margin: '0.5rem', width: "10rem"}} fullWidth variant="contained">Stay Logged In</Button>
                    </div>
                </Container>
            </DialogContent>
        </Dialog>
    )
}

export default TimeoutWarningDialog